export const SNACKBAR_SHOW = 'SNACKBAR_SHOW'
export const SNACKBAR_CHANGE_VALUE = 'SNACKBAR_CHANGE_VALUE'

export const SUB_CHANGE_VALUE = 'SUB_CHANGE_VALUE'
export const SUB_CHANGE_CHILD_VALUE = 'SUB_CHANGE_CHILD_VALUE'
export const SUB_CHANGE_ERROR = 'SUB_CHANGE_ERROR'
export const SUB_CLEAN = 'SUB_CLEAN'